import { TransformConvertorBase } from './transform.convertor';
import { Transformation } from 'app/model/dataflow/transformation';
import { DataFlowExpressionUtils } from '../../expression.util';
import { Constants } from 'app/shared/shared-constants';
import { DataFlowSchemaAdapterUtils } from '../../dataflow-schema-adapter-utils';
import { UnpivotTransformation } from 'app/model/dataflow/unpivottransformation';
import { SchemaConvertor } from './schema.convertor';
import { UnpivotPlainObject } from 'worker/app-workers/shared/plainObjects/unpivot.plainObject';
import { IResourceContext } from 'shell-models-lib';

export class UnpivotConvertor extends TransformConvertorBase {
    private get unpivotTransform(): UnpivotTransformation {
        return this.transformation as UnpivotTransformation;
    }

    private get unpivotObject(): UnpivotPlainObject {
        return this.transformObject as UnpivotPlainObject;
    }

    public async convert(contextData: IResourceContext): Promise<Transformation> {
        await super.convert(contextData);

        this.unpivotObject.groupByColumns.forEach((column) => {
            const groupByColumn = this.unpivotTransform.addGroupByColumn();
            const unescapedColumnName = Constants.dataFlowEscapedNameValidation.test(column.name)
                ? DataFlowSchemaAdapterUtils.removeWrappingCharacters(column.name)
                : column.name;
            groupByColumn.column.name = column.expression
                ? unescapedColumnName
                : DataFlowSchemaAdapterUtils.extractColumnName(unescapedColumnName);
            groupByColumn.dataFlowExpression.expression = column.expression || column.name;
        });
        this.unpivotTransform.unpivotKeyColumn = this.unpivotObject.unpivotKeyColumn
            ? SchemaConvertor.convertColumnFromPlainObject(this.unpivotObject.unpivotKeyColumn, this.unpivotTransform)
            : this.unpivotTransform.unpivotKeyColumn;
        this.unpivotTransform.unpivotedColumns =
            this.unpivotObject.unpivotedColumns.length > 0
                ? SchemaConvertor.convertColumnsFromPlainObject(
                      this.unpivotObject.unpivotedColumns,
                      this.unpivotTransform
                  )
                : this.unpivotTransform.unpivotedColumns;
        this.unpivotTransform.lateralColumnArrangement = this.unpivotObject.lateralColumnArrangement;
        this.unpivotTransform.dropNullRows = this.unpivotObject.dropNullRows;
        this.unpivotObject.pivotKeyValues.forEach((keyValue) =>
            this.unpivotTransform.pivotKeyValues.push(DataFlowExpressionUtils.extractStringConfigValue(keyValue))
        );
        this.unpivotTransform.nullValue = this.unpivotObject.nullValue;
        this.unpivotTransform.pickColumnsAsValues =
            !this.unpivotTransform.pivotKeyValues.length && !this.unpivotTransform.nullValue;

        super.postConvert();
        return this.transformation;
    }
}
